<!-- 
    For non-wrapping single dimension flex layout. Direct children must be BaseFlexItems
-->

<template>
    <BaseRenderer 
        wrapper="div"
        :class="[
            'c-flex',
            spacingXClass,
            justifyClass,
            alignItemsClass,
            inline ? 'flex-inline' : 'flex',
            wrap ? 'flex-wrap' : ''
        ]"
        child-tag-name="BaseFlexItem"
        :child-data="{
            props: childProps
        }"
    >
        <!-- @slot The default slot for BaseFlexItems -->
        <slot></slot>
    </BaseRenderer>
</template>

<script>

export default {
    props: {
        /**
        * Sets the element class to flex-inline'.
        */
        inline: Boolean,
        /**
        * If present, sets "width" prop for all children.
        */
        childWidth: {
            type: String,
            default: '',
            validator(value) {
                return [
                    '',
                    'fluid',
                    'content',
                    'auto'
                ].includes(value);
            } 
        },
        /**
        * Maps to flexbox justify content tailwind classes.
        */
        justify: {
            type: String,
            default: '',
            validator(value) {
                return [
                    '',
                    'start',
                    'end',
                    'center',
                    'space-between',
                ].includes(value);
            }
        },
        /**
        * Maps to align items tailwind classes.
        */
        alignItems: {
            type: String,
            default: '',
            validator(value){
                return [
                    '',
                    'stretch',
                    'start',
                    'end',
                    'center'
                ].includes(value);
            }
        },        
        /**
        * Space between elements
        */
        spacing: {
            type: [String, Number],
            default: 0,
        },
        /**
        * If true set a class of flex-wrap
        */
        wrap: Boolean
    }, 
    computed: {
        childProps(){
            if (!this.childWidth) {
                return {};
            }

            return {
                width: this.childWidth
            };
        },
        computedSpacing() {
            return parseInt(this.spacing);
        },
        spacingXClass() {
            switch(this.computedSpacing) {
                case 1:
                    return 'space-x-1';
                case 2:
                    return 'space-x-2';
                case 3:
                    return 'space-x-3';
                case 4:
                    return 'space-x-4';
                default:
                    return '';
            }
        },
        justifyClass(){
            switch(this.justify) {
                case 'start':
                    return 'justify-start';
                case 'end':
                    return 'justify-end';
                case 'center':
                    return 'justify-center';
                case 'between':
                    return 'justify-between';
                default:
                    return '';
            }          
        },
        alignItemsClass(){
            switch(this.alignItems) {
                case 'start':
                    return 'items-start';
                case 'end':
                    return 'items-end';
                case 'center':
                    return 'items-center';
                case 'stretch':
                    return 'items-stretch';
                default:
                    return '';
            }          
        }
    },

};
</script>